import { graphqlRequest } from "./graphql";

export interface StockPlan {
  plan_id: string;
  value: number;
  created_at: string;
  whatsub_plan: {
    plan_name: string;
    whatsub_service: {
      service_name: string;
      image_url: string;
      blurhash: string;
    };
  };
}

export interface StockPlanWithVolume extends StockPlan {
  totalValue: number;
  count: number;
}

interface GetUniquePlansResponse {
  whatsub_gc_db: StockPlan[];
}

export async function getUniquePlans(token: string): Promise<StockPlan[]> {
  const query = `
    query GetUniquePlans($where: whatsub_gc_db_bool_exp) {
      whatsub_gc_db(where: $where, distinct_on: plan_id) {
        plan_id
        value
        created_at
        whatsub_plan {
          plan_name
          whatsub_service {
            service_name
            image_url
            blurhash
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<GetUniquePlansResponse>(
    query,
    { where: { allocated: { _eq: false } } },
    token
  );
  return data.whatsub_gc_db;
}

interface GetPlanVolumeResponse {
  whatsub_gc_db_aggregate: {
    aggregate: {
      sum: { value: number | null };
      count: number;
    };
  };
}

export async function getPlanVolume(
  planId: string,
  token: string
): Promise<{ totalValue: number; count: number }> {
  const query = `
    query GetPlanVolume($plan_id: uuid!) {
      whatsub_gc_db_aggregate(where: {plan_id: {_eq: $plan_id}, allocated: {_eq: false}}) {
        aggregate {
          sum { value }
          count
        }
      }
    }
  `;
  const data = await graphqlRequest<GetPlanVolumeResponse>(
    query,
    { plan_id: planId },
    token
  );
  return {
    totalValue: data.whatsub_gc_db_aggregate.aggregate.sum.value ?? 0,
    count: data.whatsub_gc_db_aggregate.aggregate.count,
  };
}

export async function getPlansWithVolume(token: string): Promise<StockPlanWithVolume[]> {
  const plans = await getUniquePlans(token);
  const results = await Promise.all(
    plans.map(async (plan) => {
      const volume = await getPlanVolume(plan.plan_id, token);
      return { ...plan, ...volume };
    })
  );
  return results;
}
